export const MuiSelect = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      backgroundColor: '#FFF',
    },
  },
}
